import { Button } from 'antd';
import { StepLayout } from 'layouts';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ContentDescription } from 'components';

const FaultPasswordContainer = () => {
  const navigate = useNavigate();

  const next = () => {
    navigate('/agreeSignUp', { replace: true });
  };
  const gotoLogin = () => {
    navigate('/');
  };

  return (
    <StepLayout
      desc="본인인증 정보와 일치하는 계정정보가 없습니다"
      content={
        <ContentDescription>
          <p>지금 식권대장에 가입하여, 주변회사의 임직원을 고객으로 확보하세요.</p>
        </ContentDescription>
      }
      bottomDirection="vertical"
      bottom={
        <>
          <Button type="primary" onClick={next}>
            회원가입
          </Button>
          <Button type="default" onClick={gotoLogin}>
            로그인 페이지로 이동
          </Button>
        </>
      }
    />
  );
};

export default FaultPasswordContainer;
